var SORTING_METHODS = {
  ascending: '@sort/asc',
  descending: '@sort/dsc'
};
var SELECT_CONSTANTS = {
  ALL: '@all'
};
var SORT_BY = {
  DUE_DATE: 'dueDate'
};
export default {
  SORTING_METHODS: SORTING_METHODS,
  SELECT_CONSTANTS: SELECT_CONSTANTS,
  SORT_BY: SORT_BY
};